// extracted by mini-css-extract-plugin
module.exports = {"HighlightSelect":"Attachment_HighlightSelect__2xfTT","HighlightHover":"Attachment_HighlightHover__1fKmc"};